<template>
	<pui-datatable
		:modelName="modelName"
		:customizeActionAvailability="customizeActionAvailability"
		:parentModelName="parentModelName"
		:parentModel="parentModel"
		:externalFilter="externalFilter"
		:masterDetail="masterDetail"
		:readOnly="readOnly"
		:showMasterDetailFilterListBtn="true"
		:showMasterDetailFilterBtn="true"
		:showMasterDetailSortBtn="true"
		:showMasterDetailConfBtn="true"
		:modelColumnDefs="modelColumnDefs"
	></pui-datatable>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import { STATUS_DRAFT_ID } from '../../constants/imofalforms/ImoFalFormsConstants';

export default {
	name: 'imofalform5-grid',
	components: {},
	mixins: [PuiGridDetailMixin],
	data() {
		return {
			modelName: 'imofalform5',
			modelColumnDefs: {
				birthdate: {
					render: (data) => {
						return new Date(data).toLocaleDateString('es-CL');
					}
				},
				expirydate: {
					render: (data) => {
						return new Date(data).toLocaleDateString('es-CL');
					}
				}
			}
		};
	},
	methods: {
		customizeActionAvailability(actionId, parentModel) {
			if (actionId === 'puiImportAction' || actionId === 'puiExportAction') {
				return parentModel.statusid === STATUS_DRAFT_ID;
			}
		}
	}
};
</script>
